import listViewStore from '../store/Store';

export default function isConversationExpanded(rowKey: string): boolean {
    return (
        listViewStore.expandedConversationViewState.expandedRowKey == rowKey &&
        !listViewStore.expandedConversationViewState.shouldBeExpanded
    );
}
